import { render, staticRenderFns } from "./DropdownNavigation.vue?vue&type=template&id=4c03ac2a&"
import script from "./DropdownNavigation.vue?vue&type=script&lang=js&"
export * from "./DropdownNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports